<template>
  <NuxtLink
    :to="tab.to"
    class="box-border flex h-full cursor-pointer items-center border-b-[3px] px-25 font-semibold transition-all hover:border-primary hover:bg-[#fff5e5] hover:text-primary"
    :class="[
      currentPath === tab.to
        ? 'border-primary bg-[#fff5e5] text-primary'
        : 'border-white bg-white text-black-3'
    ]"
  >
    {{ tab.label }}
  </NuxtLink>
</template>

<script setup>
defineProps({
  tab: {
    type: Object,
    default: () => ({})
  }
})

const route = useRoute()

const currentPath = computed(() => {
  return route.fullPath
})
</script>

<style lang="scss" scoped></style>
